import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import QuestionPage from '../views/QuestionPage/';
import Sanitize from '../Sanitize';
import ViewResult from './ViewResult';

class ExamResult extends Component {
	 
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			acyear : '',
			exam : '',
			accyear : [],
			_message : '',
			alertClass :'',
			data : [],
			result : [],
			subject : [],
			_redirect : false,
			isview : false,
			modal : false,
			currentPage: 1,
			todosPerPage: 10,
			activePage : 1,
		}
		this.handlePageChange = this.handlePageChange.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onacChange = this.onacChange.bind(this);
	}

	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}

	onViewClick(exam,e){
		this.setState({exam : exam,modal : !this.state.modal});
	}

	toggle(e){
		this.setState({modal : !this.state.modal});
	}
	
	onacChange(e){
		this.setState({[e.target.name]:e.target.value,data : []});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getacyear();
		
	}
	
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
                $('#year option').eq(index + 1).prop('selected', true).trigger('change');
                this.getsubject();
                this.getdata();
                this.getresult();
			}
		});
	}
	
	getsubject(){
		var ac = $("#year").val();
        if(this.state.userRole == 'questionbank'){
			$("#showLoader").show();
			GetData('assignsubject/getsubbystaffid/'+ac+'/'+this.state.staffid).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson){
					this.setState({
						subject : responseJson
					});
				}
			});
		}
	}
    
    getdata(){
        var ac = $("#year").val();
		$("#showLoader").show();
		GetData('question/getresult/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				var dat = [];
                if(this.state.userRole == 'questionbank'){
                    for(var i=0;i<responseJson.length;i++){
                        if(this.checkSubject(responseJson[i].subject)){
                            dat.push(responseJson[i]);
                        }
                    }
                }
                else{
                    dat = responseJson;
				}
				this.setState({
                    data : dat
                });
			}
		});
	}
    getresult(){
        var ac = $("#year").val();
		$("#showLoader").show();
		GetData('question/getexamresult/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					result : responseJson
				});
			}
		});
	}
	
	checkSubject(subid){
		var d = this.state.subject;
		var index = d.findIndex(function(obj){
			return(obj.subject == subid);
		});
		if(index != -1){
			return true;
		}else{
			return false;
		}
	}
	
	getStatus(date){
		var today = new Date().getTime();

		var date = new Date(date).getTime();
		if(date == today){
			return 'Process';
		}
		else if(date < today){
			return 'Completed';
		}
		else if(date > today){
			return 'Upcoming';
		}
	}

	getstudcount(exam){
		var d = this.state.result;
		var dat = d.filter(function(obj){
			return(obj.exam == exam);
		});
		
		var result = Sanitize.groupByMultiple(dat, function (item) {
			return [item.regno];
		});
		return result.length;
	}
	
  render() {
	
	var acyear = this.state.accyear;
	let userData = JSON.parse(sessionStorage.getItem('userData'));
	this.state.userId = userData['userid'];
	this.state.userRole = userData['userrole'];
	this.state.staffid = userData['staffid'];
    
   // Logic for displaying current todos
        const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
        const currentTodos = this.state.data.slice(indexOfFirstTodo, indexOfLastTodo);

        const renderTodos = currentTodos.map((item,i) => {
            return  <tr>
				<td>{indexOfFirstTodo+i+1}</td>
				<td>{item.examdate} {item.fromtime} to {item.totime}</td>
				<td>{item.cls} - {item.sec}</td>
				<td>{item.subname}</td>
				<td>{item.questionname}</td>
				<td>{item.qcount} / {parseFloat(item.totalmarks)}</td>
				<td>{item.scount}</td>
				<td>{this.getstudcount(item.id)}</td>
				<td>{this.getStatus(item.examdate)}</td>
				<td>
					<button className="btn btn-warning btn-sm" onClick={this.onViewClick.bind(this,item.id)} ><i className="fa fa-eye"></i></button>
				</td>
			</tr>;
        });
	
    return (
		<div>
		  <QuestionPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="12">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card >
						<CardHeader>
                            <strong>Exam Result</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<select name="acyear" onChange={this.onacChange} required id="year">
								<option value="">Select</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="12">
                                    <Table bordered responsive>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Exam Date and Time</th>
                                                <th>Class</th>
                                                <th>Subject</th>
                                                <th>Question Id</th>
                                                <th>No.of Question / Mark</th>
                                                <th>No.of Student</th>
                                                <th>No.of Student Respond</th>
                                                <th>Status</th>
                                                <th>Manage</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderTodos}
                                        </tbody>
                                    </Table>
                                </Col>
								<Col md={12}>
									<Pagination
										activePage={this.state.activePage}
										itemsCountPerPage={this.state.todosPerPage}
										pageRangeDisplayed={3}
										totalItemsCount={this.state.data.length}
										onChange={this.handlePageChange}
									/>
								</Col>
                            </Row>
							<Modal isOpen={this.state.modal} size="lg" toggle={this.toggle} className={this.props.className}>
								<ModalHeader toggle={this.toggle}>View Result</ModalHeader>
								<ModalBody>
									<ViewResult acyear={this.state.acyear} exam={this.state.exam} />
								</ModalBody>
							</Modal>
                        </CardBody>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default ExamResult;


// WEBPACK FOOTER //
// ./src/Questions/ExamResult.js